<!-- 钢网 -->
<template>
  <BaseFormItem
    class="steel_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <BaseRadioGroup v-model="val.steel_type" @change="() => handleChange('steel_type')">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
    <BaseCheckbox 
      class="steel_type__checkbox" 
      v-model="val.steel_no_tin_open"
      :true-label="0"
      :false-label="1"
      @change="() => handleChange('steel_no_tin_open')"
    >
      不焊接物料的贴片焊盘不开窗
    </BaseCheckbox>

    <!-- 加工要求 -->
    <div v-show="isShowPosition || isShowRemark" class="steel_type__remark">
      <i :class="['steel_type__remark__linker', `linker_${val.steel_type}`]"></i>
      <!-- 收起状态 -->
      <el-collapse-transition>
        <div v-show="isFold" class="steel_type__remark__isFold">
          <div>
            <p v-if="isShowPosition">
              器件位号：<span :title="val.steel_position">{{ val.steel_position }}</span>
            </p>
            <p v-if="isShowRemark">
              钢网其它加工要求：<span :title="val.steel_remark">{{ val.steel_remark }}</span>
            </p>
          </div>
          <BaseButton type="default" round @click="() => isFold = false">
            展开备注
            <i class="el-icon-arrow-down"></i>
          </BaseButton>
        </div>
      </el-collapse-transition>
      <!-- 展开状态 -->
      <el-collapse-transition>
        <div v-show="!isFold">
          <!-- 阶梯钢网的器件位号 -->
          <el-collapse-transition>
            <div v-show="isShowPosition" class="steel_type__remark__position">
              <p class="steel_type__remark__label">
                <i>*</i> 请填写需要做阶梯的器件位号，多个逗号隔开
              </p>
              <BaseInput
                v-model="val.steel_position"
                type="textarea"
                width="100%"
                resize="none"
                placeholder="请填写需要做阶梯的器件位号，多个逗号隔开"
                maxlength="200"
                show-word-limit
                :rows="3"
                @input="() => handleEmit('steel_position')"
              />
            </div>
          </el-collapse-transition>
          <!-- 加工要求 -->
          <el-collapse-transition>
            <div v-show="isShowRemark" class="steel_type__remark__content">
              <p class="steel_type__remark__label">
                加工要求（选填）
              </p>
              <BaseInput
                v-model="val.steel_remark"
                type="textarea"
                width="100%"
                resize="none"
                placeholder="如有特殊钢网开窗要求的请说明，或提供钢网开口文件、solder paste层文件"
                maxlength="200"
                show-word-limit
                :rows="3"
                @input="() => handleEmit('steel_remark')"
              />
              <div class="steel_type__remark__upload">
                <UploadAnnex 
                  :fileUrl="val.file_steel_url"
                  :fileName="val.file_steel_name"
                  @change="handleUploadChange"
                />
              </div>
            </div>
          </el-collapse-transition>
          <div class="steel_type__remark__btn">
            <BaseTextButton @click="() => isFold = true">
              收起
              <i class="el-icon-arrow-up"></i>
            </BaseTextButton>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </BaseFormItem>
</template>

<script>
// 上传附件
import UploadAnnex from '../components/uploadAnnex'

import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    // 钢网
    steel_type: {
      type: Number,
      default: 0
    },
    // 不焊接物料的贴片焊盘不开窗
    steel_no_tin_open: {
      type: Number,
      default: 1
    },
    // 钢网加工要求
    steel_remark: {
      type: String,
      default: ''
    },
    // 阶梯钢网器件位号
    steel_position: {
      type: String,
      default: ''
    },
    // 阶梯钢网加工要求附件地址
    file_steel_url: {
      type: String,
      default: ''
    },
    // 阶梯钢网加工要求附件名称
    file_steel_name: {
      type: String,
      default: ''
    },
  },
  components: {
    UploadAnnex
  },
  data() {
    return {
      isFold: false, // 是否收起
      val: {
        steel_type: this.steel_type,
        steel_no_tin_open: this.steel_no_tin_open,
        steel_remark: this.steel_remark,
        steel_position: this.steel_position,
        file_steel_url: this.file_steel_url,
        file_steel_name: this.file_steel_name
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('steel_type')
    },
    // 是否显示阶梯钢网器件位号
    isShowPosition() {
      return this.val.steel_type == 1
    },
    // 是否显示其他加工要求
    isShowRemark() {
      return this.val.steel_no_tin_open == 0
    }
  },
  watch: {
    steel_type(newVal) {
      this.val.steel_type = newVal
    },
    steel_no_tin_open(newVal) {
      this.val.steel_no_tin_open = newVal
    },
    steel_remark(newVal) {
      this.val.steel_remark = newVal
    },
    steel_position(newVal) {
      this.val.steel_position = newVal
    },
    file_steel_url(newVal) {
      this.val.file_steel_url = newVal
    },
    file_steel_name(newVal) {
      this.val.file_steel_name = newVal
    },
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleUploadChange(data) {
      const { fileUrl, fileName } = data || {}
      this.val.file_steel_url = fileUrl || ''
      this.val.file_steel_name = fileName || ''
      this.handleEmit('file_steel_url')
      this.handleEmit('file_steel_name')
    },
    handleChange(key) {
      this.handleEmit(key)
      // 阶梯钢网 || 勾选不焊接物料的贴片焊盘不开窗 时 展开加工要求
      if ((key === 'steel_type' && this.val[key] == 1) || (key === 'steel_no_tin_open' && this.val[key] == 0)) {
        this.isFold = false
      }
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.steel_type {
  .steel_type__checkbox {
    margin-left: 10px;
  }
  .steel_type__remark {
    position: relative;
    box-sizing: border-box;
    margin-top: 5px;
    padding: 0 16px;
    width: 560px;
    border-radius: 4px;
    background-color: $--background-hover;
    .steel_type__remark__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      &.linker_0 {
        left: 7px;
      }
      &.linker_1 {
        left: 91px;
      }
    }
    .steel_type__remark__label {
      padding: 4px 0;
      color: $--color-text-primary;
      >i {
        color: $--color-danger;
      }
    }
    .steel_type__remark__upload {
      margin-top: 6px;
    }
    .steel_type__remark__btn {
      padding-bottom: 3px;
      text-align: center;
    }
    .steel_type__remark__isFold {
      box-sizing: border-box;
      padding: 4px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      >div {
        flex: 1;
        max-width: calc(100% - 96px);
        >p {
          margin-right: 10px;
          @include ellipsis;
          >span {
            color: #909399;
          }
        }
      }
    }
    ::v-deep {
      .base-button.el-button {
        padding: 0 10px;
        height: 24px;
        line-height: 22px;
      }
    }
  }
}
</style>